let defaultLandPurpose = {
    title: '',
    order: 0,
};

export default defaultLandPurpose;

